import { buildStandardReducer, buildTypes } from 'utils/reducer-utils';

export default buildStandardReducer(buildTypes('people'));



// WEBPACK FOOTER //
// ./app/routes/person/store/reducers.js